import {useLoadingContext} from 'contexts/LoadingContext';
import {useEffect} from 'react';
import {IDELoading} from './IdeLoading';
import {StandardLoading} from './StandardLoading';
import {isIdeRoute} from './ideRoute';
import {checkIsSpanishCourse} from 'utils/courseUtils';
import {useCourseId} from 'hooks/router/useUrlParams';
import {useAppOverrides} from 'contexts/AppOverridesContext';
import {resolveLoadingCourseId} from './resolveLoadingCourseId';
export function Loading() {
  const {showLoading, hideLoading} = useLoadingContext();

  useEffect(() => {
    showLoading();

    // Clean up when unmounted => hide the loading
    return () => {
      hideLoading();
    };
    // Intentionally only run once on mount/unmount
  }, [showLoading, hideLoading]);

  // We render nothing, because the actual spinner is in the global overlay.
  return null;
}

export const PartialLoading = ({className}: {className?: string}) => {
  const courseId = useCourseId();
  const loadingText = checkIsSpanishCourse(courseId)
    ? 'Cargando...'
    : 'Loading...';
  return (
    <>
      <div
        className={
          className || 'd-flex justify-content-center align-items-center'
        }
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{loadingText}</span>
        </div>
      </div>
    </>
  );
};

export const LoadingComponent = () => {
  const {courseOverrides} = useAppOverrides();

  const courseId = resolveLoadingCourseId({
    pathname: window.location.pathname,
    search: window.location.search,
    overrideCourseIds: Object.keys(courseOverrides ?? {}),
  });
  const CourseLoadingPage = courseOverrides?.[courseId]?.LoadingPage;

  if (isIdeRoute(window.location.pathname)) {
    return <IDELoading />;
  }

  // A course may override its standard loader (see CourseAppOverrides).
  if (CourseLoadingPage) {
    return <CourseLoadingPage />;
  }

  return <StandardLoading />;
};
